/**
 * Zentrale UI-Übersetzungen für die App.
 * Neue Sprache hinzufügen: Einfach ein weiteres Locale-Objekt (z. B. fr: { ... }) ergänzen –
 * SupportedLocale wird automatisch aus keyof typeof translations abgeleitet.
 */
export const translations = {
  en: {
    // --- ActiveCallView ---
    stageLabel: "Stage:",
    gatekeeper: "GATEKEEPER",
    secureLine: "SECURE LINE",
    reconnecting: "RECONNECTING…",
    connecting: "CONNECTING...",
    speaking: "SPEAKING",
    thinking: "THINKING",
    muted: "MUTED",
    listening: "Listening...",
    initializing: "Initializing...",

    // --- ConnectingView ---
    connectingGatekeeper: "Calling Front Desk...",
    connectingPersona: "Dialing {{label}}...",
    waitingForReady: "Waiting for ready...",
    cancel: "Cancel",

    // --- CountdownView ---
    countdownReady: "Get ready...",

    // --- LobbyView ---
    trainingCenter: "Training Center",
    chooseScenario: "Choose your scenario.",
    setupCall: "Setup Call",

    // --- CallSetupSheet ---
    trainingSetup: "Training Setup",
    callWith: "Call with",
    language: "Language",
    chooseLanguage: "Choose the language for the call.",
    difficulty: "Difficulty",
    challengeLevel: "Choose your challenge level",
    gatekeeperMode: "Gatekeeper Mode",
    gatekeeperActive: "ACTIVE",
    gatekeeperDescription: 'Start with the gatekeeper ("Sarah") before getting through.',
    startCall: "Start Call",
    english: "English",
    deutsch: "Deutsch",
    champion: "Champion",
    dashboardWelcomeBack: "Welcome back, {{name}} 👋",
    dashboardReadyToday: "Ready to level up today?",
    dashboardDone: "✅ DONE",
    dashboardToday: "TODAY",
    dashboardGreatJob: "Great job! You crushed today's call.",
    dashboardComeBackTomorrow: "Come back tomorrow for a new challenge",
    dashboardCallOfTheDay: "Call of the Day",
    dashboardCallOfTheDayHint: "1 min - Hard - Score 8+ for badge",
    dashboardNoSessionsLeft: "No sessions left today.",
    dashboardResetAtMidnight: "Resets at 00:00 (your local time)",
    dashboardNextResetIn: "Next reset in {{time}}",
    dashboardChecking: "Checking...",
    dashboardRefresh: "Refresh",
    dashboardGoPro: "Go Pro",
    dashboardScriptStudio: "Script Studio",
    dashboardScriptStudioDesc: "Create or improve talk tracks",
    dashboardSalesAcademy: "Sales Academy",
    dashboardSalesAcademyDesc: "Lessons and Playbooks",
    dashboardHandleObjection: "Handle Objection",
    dashboardHandleObjectionDesc: "Get tailored replies",
    dashboardLiveCallAnalyzer: "Live Call Analyzer",
    dashboardLiveCallAnalyzerDesc: "Real-time feedback",
    dashboardProBadge: "PRO",
    dashboardNewBadge: "NEW",
    dashboardColdCallBattle: "ColdCall Battle",
    dashboardColdCallBattleDesc: "Challenge AI head-to-head",
    dashboardDailyTipTitle: "Daily AI Sales Tip",
    dashboardDailyMotivationTitle: "Daily Motivation",
    dashboardCommunityHighlights: "Community Highlights",
    dashboardJoinWeeklyChallenge: "Join This Week's Challenge",
    dashboardWeeklyChallengeDesc: "Pitch your toughest product in 60 seconds.",
    dashboardYouAreIn: "You're In! Check leaderboard.",
    dashboardRepsJoined: "124 reps joined",
    dashboardJoinChallenge: "Join Challenge",
    dashboardTrendingNow: "Trending Now",
    dashboardExploreCommunity: "Explore Community",
    dashboardScriptStudioSheetTitle: "Script Studio",
    dashboardGenerateScript: "Generate Script",
    dashboardImproveScript: "Improve Script",
    dashboardLiveCallStudioSheetTitle: "Live Call Studio",
    dashboardUploadRecording: "Upload Recording",
    dashboardStartLiveCall: "Start Live Call",
    dashboardLiveAnalyzerTitle: "Live Analyzer",
    tip1: "Keep your intro under 15 seconds to maintain attention.",
    tip2: "Mirror the prospect's tone and energy level.",
    tip3: "Ask one open question before pitching your solution.",
    tip4: "Listen 60% of the time, talk 40% of the time.",
    tip5: "Always confirm the next step before ending the call.",
    quote1: "Every rejection is one step closer to your next yes.",
    quote2: "Confidence isn't about being perfect; it's about showing up consistently.",
    quote3: "The difference between average and elite is what you do when you don't feel like it.",
    quote4: "Your competition is practicing right now. So should you.",
    quote5: "Champions are made when nobody's watching.",
    callQuote1: "Every great closer started with one brave call.",
    callQuote2: "Confidence is built one conversation at a time.",
    callQuote3: "Your next breakthrough is just one call away.",
    callQuote4: "Champions practice when nobody's watching.",
    callQuote5: "The phone is your gym. Every call is a rep.",
    levelRookie: "Rookie",
    levelRisingCloser: "Rising Closer",
    levelProCloser: "Pro Closer",
    levelEliteRep: "Elite Rep",
    levelMasterCloser: "Master Closer",
    premiumBadge: "PREMIUM",
    premiumHeroTitle: "Go Pro with ColdCallCoach",
    premiumHeroSubtitle:
      "Unlock your full sales potential with AI-powered tools, unlimited calls, and advanced analytics.",
    premiumUpgradeCta: "Upgrade to Pro",
    premiumCancelAnytime: "Cancel anytime - 14-day money-back guarantee",
    premiumComparePlans: "Compare Plans",
    premiumFindFit: "Find the right fit for you",
    academyTitle: "Sales Academy",
    academySubtitle: "Master sales skills with expert-led courses",
    academyYourTrainingPath: "Your Training Path",
    academySearchPlaceholder: "Search courses...",
    academyFeedTab: "Feed",
    academyGroupsTab: "Groups",
    academyMessagesTab: "Messages",
    communityTitle: "Community",
    communitySearchPlaceholder: "Search posts, groups, or people...",
    academyCategoryAll: "All",
    academyCategoryColdCall: "Cold Call",
    academyCategoryObjections: "Objections",
    academyCategoryClosing: "Closing",
    academyCategoryVoice: "Voice",
    academyCategoryMindset: "Mindset",
    academyFilterUnlocked: "Unlocked",
    academyFilterLocked: "Locked",
    academyNoCoursesFound: "No courses found matching your search.",
    academyRecommendedNext: "Recommended Next",
    academyBasedOnLastFeedback: "Based on your last simulation feedback",
    academyStartNow: "Start Now",
    academyLearningStreak: "Learning Streak: {{count}} day in a row",
    academyLearningStreakPlural: "Learning Streak: {{count}} days in a row",
    academyLearningStreakHint: "Keep it up - consistency builds expertise.",
    communityActionNewPost: "New Post",
    communityActionCreateGroup: "Create Group",
    communityActionNewMessage: "New Message",
    communityTopWins: "Top Community Wins",
    communityNoPostsFound: "No posts found",
    communityCreateFirstPost: "Create First Post",
    communityXpSharingTip: "+10 XP for sharing a tip",
    communityNoGroupsFound: "No groups found",
    communityCreateFirstGroup: "Create First Group",
    communityJoinAndEarn: "Join and Earn XP",
    communityViewGroup: "View Group",
    communityJoinGroup: "Join Group",
    communityConversations: "Ongoing Conversations",
    communityNoMessages: "No messages yet",
    communityStartConversation: "Start Conversation",
    communityNewMessageAria: "New Message",
    communityXpPeerEngagement: "+2 XP for peer engagement",
    communityXpEarned: "+{{amount}} XP Earned!",
    communityXpForAction: "For {{action}}",
    communityActionPosting: "posting",
    communityActionCreatingGroup: "creating a group",
    communityActionPeerEngagement: "peer engagement",
    communityActionGivingKudos: "giving kudos",
    communityClose: "Close",
    communityMaybeLater: "Maybe later",
    communityCancel: "Cancel",
    communityCreate: "Create",
    communitySend: "Send",
    communityPost: "Post",
    communityTo: "To",
    communityMessage: "Message",
    communityDescription: "Description",
    communityTagOptional: "Tag (optional)",
    communityWhatsOnYourMind: "What's on your mind?",
    communityPostPlaceholder: "Share a win, ask a question, or drop a tip...",
    communityTagPlaceholder: "e.g., closing, objections, tips",
    communityCreateNewPost: "Create New Post",
    communityCreateGroup: "Create Group",
    communityGroupName: "Group Name",
    communityGroupNamePlaceholder: "e.g., SaaS Closers, Enterprise Sellers...",
    communityGroupDescriptionPlaceholder: "What's this group about?",
    communitySearchMembersPlaceholder: "Search members...",
    communityWriteMessagePlaceholder: "Write your message...",
    communityDiscardPostConfirm: "Discard draft? Your unsaved post will be lost.",
    communityDiscardGroupConfirm: "Discard group? Your unsaved group will be lost.",
    communityDiscardMessageConfirm: "Discard message? Your unsaved message will be lost.",
    communityPostTooShortTitle: "Post too short",
    communityMessageTooShortTitle: "Message too short",
    communityNameTooShortTitle: "Name too short",
    communitySelectRecipientTitle: "Select recipient",
    communityChooseRecipient: "Please choose who to message",
    communityMinCharsDescription: "Please write at least 3 characters",
    communityGroupNameMinChars: "Group name must be at least 3 characters",
    communityPostedTitle: "Posted to Community",
    communityPostedDescription: "Your post is now live",
    communityFailedToPostTitle: "Failed to post",
    communityFailedToCreateGroupTitle: "Failed to create group",
    communityFailedToSendMessageTitle: "Failed to send message",
    communityTryAgain: "Please try again",
    communityCharsCount: "{{count}} characters",
    communityMinCharsSuffix: "(min. 3)",
    communityTipLabel: "Tip",
    communityPostTip: "Share specific tactics or lessons learned. The community loves actionable insights!",
    communityGroupTip: "Choose a clear, specific name. Great groups focus on a niche topic or skill level.",
    communityMessageTip: "Start with a question or share something helpful to get the conversation going!",
    academyExclusiveProSession: "Exclusive Pro Session",
    academyUnlockAdvancedLessons: "Unlock advanced lessons and audio library.",
    academyBenefitExpertTactics: "Expert tactics and breakdowns",
    academyBenefitNewLessonsWeekly: "New lessons weekly",
    academyBenefitAudioLibrary: "Audio library included",
    academyUnlockAtLevel: "Unlock at Level {{level}}",
    academyCompleteLessonsToGainXp: "Complete lessons and practice calls to gain XP.",
    academyCurrentLevel: "Current Level: {{level}}",
    academyLevelsToUnlock: "{{count}} level to unlock",
    academyLevelsToUnlockPlural: "{{count}} levels to unlock",
    academySeeHowToLevelUp: "See How to Level Up",
    academyPathBeginner: "Build your foundation with quick wins.",
    academyPathIntermediate: "Level up your skills with advanced tactics.",
    academyPathAdvanced: "Master elite techniques for top performers.",
    academyProgressHintContinue: "Complete lessons to level up and unlock advanced content.",
    academyProgressHintStart: "Start your first course to begin your journey.",
    academyLevelBeginnerTitle: "Level 1 - Beginner Lessons",
    academyLevelIntermediateTitle: "Level 3 - Intermediate Challenges",
    academyLevelAdvancedTitle: "Level 5+ - Pro Mastery",
    academyProgressLine: "Level {{level}} - {{completed}} / {{total}} courses",
    academyFirstStepTaken: "First step taken - let's build your momentum.",
    academyMasteredAll: "You've mastered them all!",
    academyProSpotlightTitle: "Pro Spotlight - Exclusive Lessons for Ambitious Sellers",
    academyProSpotlightSubtitle: "Unlock advanced tactics designed for elite reps.",
    academyProPill: "PRO",
    academyExclusiveLabel: "Exclusive",
    academyDifficultyBeginner: "Beginner",
    academyDifficultyIntermediate: "Intermediate",
    academyDifficultyAdvanced: "Advanced",
    academyDifficultyExpert: "Expert",
    academyCompletedAria: "Completed. You earned {{xp}} XP.",
    academyCompletedBadge: "Completed +{{xp}} XP",
    academyRecommendedBadge: "RECOMMENDED",
    academyXpProgressAria: "{{earned}} out of {{total}} XP earned.",
    academyXpEarnAria: "Earn {{xp}} XP when you complete this session.",
    academyXpEarnLabel: "Earn +{{xp}} XP",
    academyProExclusiveAria: "Pro exclusive content",
    academyLevelLockedAria: "Locked. Requires level {{level}} to unlock.",
    academyMinLevelAria: "Minimum level {{level}}",
    academyProgressComplete: "{{progress}}% complete",
    academyKeyTakeaways: "Key Takeaways",
    academyCompleted: "Completed",
    academyMarkAsCompleted: "Mark as Completed",
    academyCourse1Title: "Mastering the First 15 Seconds",
    academyCourse1Summary: "Learn to grab attention in the first 15 seconds.",
    academyCourse1Content:
      "The opening 15 seconds of any cold call determine whether you get 5 minutes or 5 seconds of attention. This lesson teaches you how to craft a powerful hook that immediately communicates value, creates curiosity, and positions you as someone worth listening to. You'll learn the three-part framework used by top performers to cut through noise and earn respect from skeptical prospects.",
    academyCourse1Takeaway1: "Use the Name-Permission-Hook framework to structure your opener",
    academyCourse1Takeaway2: "Lead with a problem, not your product or company name",
    academyCourse1Takeaway3: "Practice keeping your intro to exactly 12-15 seconds",
    academyCourse2Title: "Ask Better Discovery Questions",
    academyCourse2Summary: "Uncover pain points without interrogating.",
    academyCourse2Content:
      "Great salespeople don't pitch-they diagnose. This lesson shows you how to ask open-ended questions that surface real business challenges, build trust, and position you as a strategic partner. Learn the difference between surface-level questions and ones that reveal budget authority and urgency.",
    academyCourse2Takeaway1: "Use the 'Tell me about...' framework to open conversations",
    academyCourse2Takeaway2: "Ask follow-up questions that dig 2-3 levels deeper",
    academyCourse2Takeaway3: "Listen for pain signals: frustration, time wasted, missed goals",
    academyCourse3Title: "Handling the 'Not Interested' Objection",
    academyCourse3Summary: "Turn objections into opportunity.",
    academyCourse3Content:
      "'Not interested' is the most common objection in cold calling-and also the easiest to overcome when you know how. This lesson teaches you a three-step framework for acknowledging the objection, creating curiosity, and earning permission to continue the conversation without sounding pushy or defensive.",
    academyCourse3Takeaway1: "Never argue with 'not interested'-acknowledge it first",
    academyCourse3Takeaway2: "Use pattern interrupts: 'That's fair. Can I ask why?'",
    academyCourse3Takeaway3: "Offer a micro-commitment instead of a full pitch",
    academyCourse4Title: "Closing with Confidence",
    academyCourse4Summary: "Propose next steps that prospects accept.",
    academyCourse4Content:
      "Weak closers use vague language like 'let's touch base soon.' Strong closers propose specific next steps with dates, times, and clear outcomes. This lesson teaches you how to confidently ask for the meeting, follow-up, or demo-and how to handle pushback without backing down or sounding desperate.",
    academyCourse4Takeaway1: "Always propose two specific time slots",
    academyCourse4Takeaway2: "Use assumptive language: 'Does Tuesday at 2pm work?'",
    academyCourse4Takeaway3: "If they hesitate, isolate the objection before re-closing",
    academyCourse5Title: "Voice, Tone, and Pacing",
    academyCourse5Summary: "Sound confident without sounding scripted.",
    academyCourse5Content:
      "Your words matter, but how you say them matters more. This lesson covers the vocal techniques top performers use to sound confident, credible, and conversational-even when reading from a script. Learn how to control your pace, use strategic pauses, and mirror your prospect's energy without losing your own authority.",
    academyCourse5Takeaway1: "Slow down-rushed speech signals nervousness",
    academyCourse5Takeaway2: "Use downward inflection to sound confident, not questioning",
    academyCourse5Takeaway3: "Mirror the prospect's tone to build rapport quickly",
    academyCourse6Title: "Building Mental Toughness",
    academyCourse6Summary: "Build mental toughness - stay sharp under pressure.",
    academyCourse6Content:
      "Cold calling is a mental game. The best reps don't avoid rejection-they process it faster. This lesson teaches you how to reframe rejection, maintain emotional control between calls, and build the resilience required to stay sharp through 50+ dials a day. You'll learn the mindset shifts that separate top 10% performers from everyone else.",
    academyCourse6Takeaway1: "Rejection is feedback, not failure-detach outcome from identity",
    academyCourse6Takeaway2: "Use a 10-second reset ritual between calls",
    academyCourse6Takeaway3: "Track activity metrics, not just conversion-control what you can",
    academyCourse7Title: "Advanced Objection Reversal Tactics",
    academyCourse7Summary: "Turn 'no' into momentum with strategic reframing.",
    academyCourse7Content:
      "Elite closers don't just overcome objections-they use them as leverage. This advanced lesson reveals the psychological frameworks behind reframing resistance into curiosity and momentum. Learn the exact language patterns that convert skeptical prospects into engaged buyers.",
    academyCourse7Takeaway1: "Use the 'Feel-Felt-Found' framework with modern variations",
    academyCourse7Takeaway2: "Apply strategic silence after objection handling",
    academyCourse7Takeaway3: "Identify micro-commitments that lead to macro-wins",
    academyCourse8Title: "Negotiation Psychology for Sales",
    academyCourse8Summary: "Master the psychology behind high-stakes deals.",
    academyCourse8Content:
      "Negotiation isn't about compromise-it's about understanding psychological triggers and decision-making patterns. This pro-level course teaches you how to anchor pricing, use reciprocity, and create urgency without pressure. Learn from real-world enterprise deals that closed at 150%+ of target.",
    academyCourse8Takeaway1: "Anchor high and let them negotiate down strategically",
    academyCourse8Takeaway2: "Use the 'takeaway' technique to create perceived scarcity",
    academyCourse8Takeaway3: "Master the pause: silence after pricing is your secret weapon",
    academyCourse9Title: "Call Recording Breakdown: $100k Deal",
    academyCourse9Summary: "Exclusive breakdown of a real 6-figure call.",
    academyCourse9Content:
      "Listen to and analyze a real call recording that resulted in a $100k+ enterprise deal. We break down every decision, tactical move, and psychological play that led to the close. This is as close as you'll get to riding along with a top 1% performer.",
    academyCourse9Takeaway1: "See how rapport-building happens naturally in high-stakes calls",
    academyCourse9Takeaway2: "Learn when to push and when to let the prospect lead",
    academyCourse9Takeaway3:
      "Identify the exact moment the deal was won (spoiler: it's earlier than you think)",
  },
  de: {
    // --- ActiveCallView ---
    stageLabel: "Phase:",
    gatekeeper: "ZENTRALE",
    secureLine: "SECURE LINE",
    reconnecting: "VERBINDE NEU…",
    connecting: "VERBINDE...",
    speaking: "SPEAKING",
    thinking: "THINKING",
    muted: "STUMM",
    listening: "Höre zu...",
    initializing: "Starte...",

    // --- ConnectingView ---
    connectingGatekeeper: "Rufe Empfang an...",
    connectingPersona: "Wähle {{label}}...",
    waitingForReady: "Warte auf Bereitschaft...",
    cancel: "Abbrechen",

    // --- CountdownView ---
    countdownReady: "Gleich geht's los...",

    // --- LobbyView ---
    trainingCenter: "Training Center",
    chooseScenario: "Wähle dein Szenario.",
    setupCall: "Anruf vorbereiten",

    // --- CallSetupSheet ---
    trainingSetup: "Training Setup",
    callWith: "Anruf mit",
    language: "Sprache",
    chooseLanguage: "Wähle die Sprache für das Gespräch.",
    difficulty: "Schwierigkeit",
    challengeLevel: "Wie schwer soll es sein?",
    gatekeeperMode: "Gatekeeper-Modus",
    gatekeeperActive: "AKTIV",
    gatekeeperDescription: 'Starte bei der Vorzimmerdame ("Sarah"), bevor du durchgestellt wirst.',
    startCall: "Anruf Starten",
    english: "English",
    deutsch: "Deutsch",
    champion: "Champion",
    dashboardWelcomeBack: "Willkommen zurueck, {{name}} 👋",
    dashboardReadyToday: "Bereit, heute ein Level hoeher zu gehen?",
    dashboardDone: "✅ FERTIG",
    dashboardToday: "HEUTE",
    dashboardGreatJob: "Stark! Du hast den heutigen Call gemeistert.",
    dashboardComeBackTomorrow: "Komm morgen fuer eine neue Challenge zurueck",
    dashboardCallOfTheDay: "Call des Tages",
    dashboardCallOfTheDayHint: "1 Min - Schwer - Score 8+ fuer Badge",
    dashboardNoSessionsLeft: "Keine Sessions mehr heute.",
    dashboardResetAtMidnight: "Reset um 00:00 (deine lokale Zeit)",
    dashboardNextResetIn: "Naechster Reset in {{time}}",
    dashboardChecking: "Pruefe...",
    dashboardRefresh: "Aktualisieren",
    dashboardGoPro: "Go Pro",
    dashboardScriptStudio: "Script Studio",
    dashboardScriptStudioDesc: "Erstelle oder verbessere Talk Tracks",
    dashboardSalesAcademy: "Sales Academy",
    dashboardSalesAcademyDesc: "Lektionen und Playbooks",
    dashboardHandleObjection: "Einwand behandeln",
    dashboardHandleObjectionDesc: "Massgeschneiderte Antworten erhalten",
    dashboardLiveCallAnalyzer: "Live Call Analyzer",
    dashboardLiveCallAnalyzerDesc: "Feedback in Echtzeit",
    dashboardProBadge: "PRO",
    dashboardNewBadge: "NEU",
    dashboardColdCallBattle: "ColdCall Battle",
    dashboardColdCallBattleDesc: "Fordere die KI im Duell heraus",
    dashboardDailyTipTitle: "Taeglicher AI Sales Tipp",
    dashboardDailyMotivationTitle: "Taegliche Motivation",
    dashboardCommunityHighlights: "Community Highlights",
    dashboardJoinWeeklyChallenge: "Nimm an der Wochen-Challenge teil",
    dashboardWeeklyChallengeDesc: "Pitchen dein haertestes Produkt in 60 Sekunden.",
    dashboardYouAreIn: "Du bist dabei! Check das Leaderboard.",
    dashboardRepsJoined: "124 Reps sind dabei",
    dashboardJoinChallenge: "Challenge starten",
    dashboardTrendingNow: "Jetzt im Trend",
    dashboardExploreCommunity: "Community entdecken",
    dashboardScriptStudioSheetTitle: "Script Studio",
    dashboardGenerateScript: "Script erstellen",
    dashboardImproveScript: "Script verbessern",
    dashboardLiveCallStudioSheetTitle: "Live Call Studio",
    dashboardUploadRecording: "Aufnahme hochladen",
    dashboardStartLiveCall: "Live Call starten",
    dashboardLiveAnalyzerTitle: "Live Analyzer",
    tip1: "Halte deinen Einstieg unter 15 Sekunden, um Aufmerksamkeit zu halten.",
    tip2: "Spiegele Ton und Energielevel deines Gegenuebers.",
    tip3: "Stelle eine offene Frage, bevor du pitchst.",
    tip4: "Hoere zu 60%, rede 40%.",
    tip5: "Bestaetige immer den naechsten Schritt vor dem Auflegen.",
    quote1: "Jede Absage bringt dich naeher zum naechsten Ja.",
    quote2: "Selbstvertrauen heisst nicht perfekt sein, sondern konstant antreten.",
    quote3: "Der Unterschied zwischen gut und elite ist, was du tust, wenn du keine Lust hast.",
    quote4: "Deine Konkurrenz trainiert gerade. Du solltest es auch tun.",
    quote5: "Champions werden gemacht, wenn niemand zuschaut.",
    callQuote1: "Jeder starke Closer begann mit einem mutigen Anruf.",
    callQuote2: "Selbstvertrauen entsteht durch jedes einzelne Gespraech.",
    callQuote3: "Dein naechster Durchbruch ist nur einen Call entfernt.",
    callQuote4: "Champions trainieren, wenn niemand zuschaut.",
    callQuote5: "Das Telefon ist dein Gym. Jeder Call ist eine Wiederholung.",
    levelRookie: "Rookie",
    levelRisingCloser: "Aufstrebender Closer",
    levelProCloser: "Pro Closer",
    levelEliteRep: "Elite Rep",
    levelMasterCloser: "Master Closer",
    premiumBadge: "PREMIUM",
    premiumHeroTitle: "Werde Pro mit ColdCallCoach",
    premiumHeroSubtitle:
      "Entfalte dein volles Sales-Potenzial mit KI-Tools, unbegrenzten Calls und erweiterten Analysen.",
    premiumUpgradeCta: "Auf Pro upgraden",
    premiumCancelAnytime: "Jederzeit kuendbar - 14 Tage Geld-zurueck-Garantie",
    premiumComparePlans: "Plaene vergleichen",
    premiumFindFit: "Finde den passenden Plan fuer dich",
    academyTitle: "Sales Academy",
    academySubtitle: "Meistere Sales-Skills mit Expertenkursen",
    academyYourTrainingPath: "Dein Trainingspfad",
    academySearchPlaceholder: "Kurse durchsuchen...",
    academyFeedTab: "Feed",
    academyGroupsTab: "Gruppen",
    academyMessagesTab: "Nachrichten",
    communityTitle: "Community",
    communitySearchPlaceholder: "Suche nach Posts, Gruppen oder Personen...",
    academyCategoryAll: "Alle",
    academyCategoryColdCall: "Cold Call",
    academyCategoryObjections: "Einwaende",
    academyCategoryClosing: "Closing",
    academyCategoryVoice: "Stimme",
    academyCategoryMindset: "Mindset",
    academyFilterUnlocked: "Freigeschaltet",
    academyFilterLocked: "Gesperrt",
    academyNoCoursesFound: "Keine Kurse passend zur Suche gefunden.",
    academyRecommendedNext: "Als naechstes empfohlen",
    academyBasedOnLastFeedback: "Basierend auf deinem letzten Simulationsfeedback",
    academyStartNow: "Jetzt starten",
    academyLearningStreak: "Lernserie: {{count}} Tag in Folge",
    academyLearningStreakPlural: "Lernserie: {{count}} Tage in Folge",
    academyLearningStreakHint: "Bleib dran - Konstanz baut Expertise auf.",
    communityActionNewPost: "Neuer Post",
    communityActionCreateGroup: "Gruppe erstellen",
    communityActionNewMessage: "Neue Nachricht",
    communityTopWins: "Top Community Erfolge",
    communityNoPostsFound: "Keine Posts gefunden",
    communityCreateFirstPost: "Ersten Post erstellen",
    communityXpSharingTip: "+10 XP fuer das Teilen eines Tipps",
    communityNoGroupsFound: "Keine Gruppen gefunden",
    communityCreateFirstGroup: "Erste Gruppe erstellen",
    communityJoinAndEarn: "Beitreten und XP sammeln",
    communityViewGroup: "Gruppe ansehen",
    communityJoinGroup: "Gruppe beitreten",
    communityConversations: "Laufende Konversationen",
    communityNoMessages: "Noch keine Nachrichten",
    communityStartConversation: "Konversation starten",
    communityNewMessageAria: "Neue Nachricht",
    communityXpPeerEngagement: "+2 XP fuer Community-Austausch",
    communityXpEarned: "+{{amount}} XP erhalten!",
    communityXpForAction: "Fuer {{action}}",
    communityActionPosting: "Posten",
    communityActionCreatingGroup: "Gruppenerstellung",
    communityActionPeerEngagement: "Austausch",
    communityActionGivingKudos: "Kudos geben",
    communityClose: "Schliessen",
    communityMaybeLater: "Spaeter",
    communityCancel: "Abbrechen",
    communityCreate: "Erstellen",
    communitySend: "Senden",
    communityPost: "Posten",
    communityTo: "An",
    communityMessage: "Nachricht",
    communityDescription: "Beschreibung",
    communityTagOptional: "Tag (optional)",
    communityWhatsOnYourMind: "Was geht dir gerade durch den Kopf?",
    communityPostPlaceholder: "Teile einen Erfolg, stelle eine Frage oder gib einen Tipp...",
    communityTagPlaceholder: "z. B. closing, objections, tipps",
    communityCreateNewPost: "Neuen Post erstellen",
    communityCreateGroup: "Gruppe erstellen",
    communityGroupName: "Gruppenname",
    communityGroupNamePlaceholder: "z. B. SaaS Closer, Enterprise Seller...",
    communityGroupDescriptionPlaceholder: "Worum geht es in dieser Gruppe?",
    communitySearchMembersPlaceholder: "Mitglieder suchen...",
    communityWriteMessagePlaceholder: "Schreibe deine Nachricht...",
    communityDiscardPostConfirm: "Entwurf verwerfen? Dein ungespeicherter Post geht verloren.",
    communityDiscardGroupConfirm: "Gruppe verwerfen? Deine ungespeicherte Gruppe geht verloren.",
    communityDiscardMessageConfirm: "Nachricht verwerfen? Deine ungespeicherte Nachricht geht verloren.",
    communityPostTooShortTitle: "Post zu kurz",
    communityMessageTooShortTitle: "Nachricht zu kurz",
    communityNameTooShortTitle: "Name zu kurz",
    communitySelectRecipientTitle: "Empfaenger waehlen",
    communityChooseRecipient: "Bitte waehle, wem du schreiben moechtest",
    communityMinCharsDescription: "Bitte mindestens 3 Zeichen eingeben",
    communityGroupNameMinChars: "Der Gruppenname muss mindestens 3 Zeichen haben",
    communityPostedTitle: "In der Community gepostet",
    communityPostedDescription: "Dein Post ist jetzt live",
    communityFailedToPostTitle: "Posten fehlgeschlagen",
    communityFailedToCreateGroupTitle: "Gruppe konnte nicht erstellt werden",
    communityFailedToSendMessageTitle: "Nachricht konnte nicht gesendet werden",
    communityTryAgain: "Bitte versuche es erneut",
    communityCharsCount: "{{count}} Zeichen",
    communityMinCharsSuffix: "(min. 3)",
    communityTipLabel: "Tipp",
    communityPostTip:
      "Teile konkrete Taktiken oder Learnings. Die Community liebt umsetzbare Insights!",
    communityGroupTip:
      "Waehle einen klaren, spezifischen Namen. Gute Gruppen fokussieren ein Nischenthema oder Skill-Level.",
    communityMessageTip:
      "Starte mit einer Frage oder teile etwas Hilfreiches, um die Konversation ins Rollen zu bringen!",
    academyExclusiveProSession: "Exklusive Pro Session",
    academyUnlockAdvancedLessons: "Schalte erweiterte Lektionen und Audio-Bibliothek frei.",
    academyBenefitExpertTactics: "Expertentaktiken und Breakdowns",
    academyBenefitNewLessonsWeekly: "Neue Lektionen jede Woche",
    academyBenefitAudioLibrary: "Audio-Bibliothek inklusive",
    academyUnlockAtLevel: "Freischalten auf Level {{level}}",
    academyCompleteLessonsToGainXp: "Schliesse Lektionen und Uebungs-Calls ab, um XP zu sammeln.",
    academyCurrentLevel: "Aktuelles Level: {{level}}",
    academyLevelsToUnlock: "{{count}} Level bis zur Freischaltung",
    academyLevelsToUnlockPlural: "{{count}} Level bis zur Freischaltung",
    academySeeHowToLevelUp: "So steigst du im Level auf",
    academyPathBeginner: "Baue dein Fundament mit schnellen Erfolgen auf.",
    academyPathIntermediate: "Steigere deine Skills mit fortgeschrittenen Taktiken.",
    academyPathAdvanced: "Beherrsche Elite-Techniken fuer Top-Performer.",
    academyProgressHintContinue:
      "Schliesse Lektionen ab, um im Level aufzusteigen und fortgeschrittene Inhalte freizuschalten.",
    academyProgressHintStart: "Starte deinen ersten Kurs und beginne deine Reise.",
    academyLevelBeginnerTitle: "Level 1 - Einsteigerlektionen",
    academyLevelIntermediateTitle: "Level 3 - Fortgeschrittene Challenges",
    academyLevelAdvancedTitle: "Level 5+ - Pro Mastery",
    academyProgressLine: "Level {{level}} - {{completed}} / {{total}} Kurse",
    academyFirstStepTaken: "Erster Schritt geschafft - jetzt bauen wir Momentum auf.",
    academyMasteredAll: "Du hast sie alle gemeistert!",
    academyProSpotlightTitle: "Pro Spotlight - Exklusive Lektionen fuer ambitionierte Seller",
    academyProSpotlightSubtitle: "Schalte fortgeschrittene Taktiken fuer Elite-Reps frei.",
    academyProPill: "PRO",
    academyExclusiveLabel: "Exklusiv",
    academyDifficultyBeginner: "Einsteiger",
    academyDifficultyIntermediate: "Mittelstufe",
    academyDifficultyAdvanced: "Fortgeschritten",
    academyDifficultyExpert: "Experte",
    academyCompletedAria: "Abgeschlossen. Du hast {{xp}} XP erhalten.",
    academyCompletedBadge: "Abgeschlossen +{{xp}} XP",
    academyRecommendedBadge: "EMPFOHLEN",
    academyXpProgressAria: "{{earned}} von {{total}} XP erhalten.",
    academyXpEarnAria: "Verdiene {{xp}} XP, wenn du diese Session abschliesst.",
    academyXpEarnLabel: "Verdiene +{{xp}} XP",
    academyProExclusiveAria: "Pro exklusiver Inhalt",
    academyLevelLockedAria: "Gesperrt. Benoetigt Level {{level}} zum Freischalten.",
    academyMinLevelAria: "Mindestlevel {{level}}",
    academyProgressComplete: "{{progress}}% abgeschlossen",
    academyKeyTakeaways: "Wichtigste Erkenntnisse",
    academyCompleted: "Abgeschlossen",
    academyMarkAsCompleted: "Als abgeschlossen markieren",
    academyCourse1Title: "Die ersten 15 Sekunden meistern",
    academyCourse1Summary: "Lerne, in den ersten 15 Sekunden Aufmerksamkeit zu gewinnen.",
    academyCourse1Content:
      "Die ersten 15 Sekunden eines Cold Calls entscheiden, ob du 5 Minuten oder 5 Sekunden Aufmerksamkeit bekommst. Diese Lektion zeigt dir, wie du einen starken Hook baust, der sofort Wert kommuniziert, Neugier weckt und dich als relevante Person positioniert. Du lernst das Drei-Teile-Framework von Top-Performern.",
    academyCourse1Takeaway1:
      "Nutze das Name-Permission-Hook Framework fuer einen strukturierten Einstieg",
    academyCourse1Takeaway2: "Fuehre mit einem Problem, nicht mit Produkt oder Firmenname",
    academyCourse1Takeaway3: "Halte dein Intro konsequent bei 12-15 Sekunden",
    academyCourse2Title: "Bessere Discovery-Fragen stellen",
    academyCourse2Summary: "Entdecke Pain Points ohne Verhoer-Feeling.",
    academyCourse2Content:
      "Starke Salespeople pitchen nicht-sie diagnostizieren. Diese Lektion zeigt dir, wie offene Fragen echte Business-Herausforderungen sichtbar machen, Vertrauen aufbauen und dich als strategischen Partner positionieren.",
    academyCourse2Takeaway1: "Nutze das 'Erzaehl mir von...' Framework fuer den Einstieg",
    academyCourse2Takeaway2: "Stelle Follow-up-Fragen, die 2-3 Ebenen tiefer gehen",
    academyCourse2Takeaway3: "Achte auf Pain-Signale: Frust, Zeitverlust, verfehlte Ziele",
    academyCourse3Title: "Mit 'Kein Interesse' professionell umgehen",
    academyCourse3Summary: "Verwandle Einwaende in Chancen.",
    academyCourse3Content:
      "'Kein Interesse' ist der haeufigste Einwand im Cold Calling-und einer der einfachsten, wenn du die richtige Struktur hast. Diese Lektion zeigt dir ein 3-Schritte-Framework, um Einwaende anzuerkennen, Neugier zu wecken und die Erlaubnis zum Weiterreden zu erhalten.",
    academyCourse3Takeaway1: "Diskutiere nie gegen 'kein Interesse' an-erkenne es zuerst an",
    academyCourse3Takeaway2: "Nutze Pattern Interrupts: 'Verstaendlich. Darf ich fragen warum?'",
    academyCourse3Takeaway3: "Biete ein Micro-Commitment statt eines Voll-Pitches an",
    academyCourse4Title: "Selbstbewusst closen",
    academyCourse4Summary: "Schlage naechste Schritte vor, die akzeptiert werden.",
    academyCourse4Content:
      "Schwache Closer nutzen vage Formulierungen. Starke Closer schlagen klare naechste Schritte mit Zeitfenstern vor. Diese Lektion zeigt dir, wie du selbstbewusst nach Meeting, Follow-up oder Demo fragst-und mit Einwaenden ruhig umgehst.",
    academyCourse4Takeaway1: "Schlage immer zwei konkrete Zeitfenster vor",
    academyCourse4Takeaway2: "Nutze assumptive Sprache: 'Passt Dienstag 14 Uhr?'",
    academyCourse4Takeaway3: "Bei Zoegern: Einwand isolieren und erneut closen",
    academyCourse5Title: "Stimme, Ton und Sprechtempo",
    academyCourse5Summary: "Souveraen klingen ohne skriptartig zu wirken.",
    academyCourse5Content:
      "Worte zaehlen, aber wie du sie sagst zaehlt mehr. Diese Lektion zeigt vokale Techniken, mit denen Top-Performer souveraen und glaubwuerdig klingen-auch mit Skript.",
    academyCourse5Takeaway1: "Langsamer sprechen-zu hohes Tempo wirkt nervoes",
    academyCourse5Takeaway2: "Nutze fallende Intonation fuer mehr Souveraenitaet",
    academyCourse5Takeaway3: "Spiegele den Ton des Prospects fuer schnellen Rapport",
    academyCourse6Title: "Mentale Staerke aufbauen",
    academyCourse6Summary: "Bleib unter Druck mental stark und fokussiert.",
    academyCourse6Content:
      "Cold Calling ist ein mentales Spiel. Top-Reps vermeiden Ablehnung nicht-sie verarbeiten sie schneller. Diese Lektion hilft dir, Ablehnung neu zu rahmen, zwischen Calls ruhig zu bleiben und Resilienz aufzubauen.",
    academyCourse6Takeaway1: "Ablehnung ist Feedback, kein Versagen",
    academyCourse6Takeaway2: "Nutze ein 10-Sekunden-Reset-Ritual zwischen Calls",
    academyCourse6Takeaway3: "Tracke Aktivitaetsmetriken, nicht nur Conversion",
    academyCourse7Title: "Advanced Objection Reversal Tactics",
    academyCourse7Summary: "Verwandle 'Nein' in Momentum durch Reframing.",
    academyCourse7Content:
      "Elite-Closer ueberwinden Einwaende nicht nur-sie nutzen sie als Hebel. Diese Lektion zeigt psychologische Frameworks fuer Reframing in Richtung Neugier und Momentum.",
    academyCourse7Takeaway1: "Nutze das 'Feel-Felt-Found' Framework in moderner Form",
    academyCourse7Takeaway2: "Setze strategische Stille nach Einwandbehandlung ein",
    academyCourse7Takeaway3: "Finde Micro-Commitments fuer Macro-Wins",
    academyCourse8Title: "Verhandlungspsychologie im Sales",
    academyCourse8Summary: "Beherrsche die Psychologie hinter High-Stakes-Deals.",
    academyCourse8Content:
      "Verhandlung bedeutet nicht Kompromiss, sondern psychologische Trigger zu verstehen. Dieser Pro-Kurs zeigt dir Anchoring, Reciprocity und Dringlichkeit ohne Druck.",
    academyCourse8Takeaway1: "Ankere hoch und verhandle strategisch herunter",
    academyCourse8Takeaway2: "Nutze die 'Takeaway' Technik fuer wahrgenommene Knappheit",
    academyCourse8Takeaway3: "Meistere die Pause: Stille nach Preisnennung ist Macht",
    academyCourse9Title: "Call Recording Breakdown: 100k-Dollar-Deal",
    academyCourse9Summary: "Exklusive Analyse eines echten 6-stelligen Calls.",
    academyCourse9Content:
      "Analysiere einen echten Call, der zu einem 100k+ Enterprise-Deal fuehrte. Wir zerlegen Entscheidungen, Taktiken und psychologische Muster bis zum Abschluss.",
    academyCourse9Takeaway1: "Sieh, wie Rapport in High-Stakes-Calls natuerlich entsteht",
    academyCourse9Takeaway2: "Lerne, wann du pushen und wann du fuehren lassen solltest",
    academyCourse9Takeaway3: "Erkenne den exakten Moment des Deal-Wins",
  },
} as const;

export const defaultLocale = "en" as const;
export type SupportedLocale = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en;
export const resources = {
  en: { translation: translations.en },
  de: { translation: translations.de },
} as const;

/** Gibt die Übersetzungen für die gewählte Sprache zurück (Fallback: en). */
export function t(locale: SupportedLocale): (typeof translations)[SupportedLocale] {
  return (translations[locale] ?? translations.en) as (typeof translations)[SupportedLocale];
}

/** Ersetzt Platzhalter wie {{label}} in einer Übersetzungszeichenkette. */
export function interpolate(template: string, vars: Record<string, string>): string {
  return Object.entries(vars).reduce(
    (acc, [key, value]) => acc.replace(new RegExp(`\\{\\{${key}\\}\\}`, "g"), value),
    template
  );
}
